/**
 * @desc 库容使用率数据导出
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: defs.wms.PositionStorageCapacityRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/warehousePosition/positionCapacityUtilizationExportList`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
